module.exports = __webpack_public_path__ + "static/media/onewaytrip.65b4931f.png";